import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { FormGroup } from '@angular/forms';
import { Company, CompaniesService, OrderCreationRequirements } from 'src/app/core/companies.service';

@Component({
  selector: 'app-companies-ticket-dialog',
  templateUrl: './companies-ticket-dialog.component.html',
  styleUrls: ['./companies-ticket-dialog.component.scss'],
})
export class CompaniesTicketDialogComponent {
  company?: Company;
  company_business_name?: string;
  is_edit_running: boolean = false;
  company_order_ticket_requirements_from_group: FormGroup =
    this.form_service.company_order_ticket_requirements_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesTicketDialogComponent>,
    private form_service: FormService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company = data.company;
    this.company_business_name = this.company?.business_name;
  }

  ngOnInit(): void {
    if (this.company) {
      const min_amount: number = this.company.order_requirements?.min_amount || 20000;
      const max_amount: number = this.company.order_requirements?.max_amount || 200000;

      this.company_order_ticket_requirements_from_group
        .get(this.form_service.min_amount_label)
        ?.setValue(min_amount / 100);
      this.company_order_ticket_requirements_from_group
        .get(this.form_service.max_amount_label)
        ?.setValue(max_amount / 100);
      this.company_order_ticket_requirements_from_group
        .get(this.form_service.is_bnpl_long_enabled_label)
        ?.setValue(this.company?.order_requirements?.is_bnpl_long_enabled);
      this.company_order_ticket_requirements_from_group
        .get(this.form_service.is_sdd_payment_enabled_label)
        ?.setValue(this.company?.order_requirements?.is_sdd_payment_enabled || false);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    const order_requirements: OrderCreationRequirements = {
      min_amount:
        this.company_order_ticket_requirements_from_group.get(this.form_service.min_amount_label)?.value * 100,
      max_amount:
        this.company_order_ticket_requirements_from_group.get(this.form_service.max_amount_label)?.value * 100,
      is_bnpl_long_enabled:
        this.company_order_ticket_requirements_from_group.get(this.form_service.is_bnpl_long_enabled_label)?.value ||
        false,
      is_sdd_payment_enabled:
        this.company_order_ticket_requirements_from_group.get(this.form_service.is_sdd_payment_enabled_label)?.value ||
        false,
    };

    if (this.company?.company_id) {
      this.setOrderRequirements(this.company.company_id, order_requirements);
    }
  }

  setOrderRequirements(company_id: string, order_requirements: OrderCreationRequirements): void {
    console.log(order_requirements);
    this.is_edit_running = true;
    this.companies_service.setOrderRequirements(company_id, order_requirements).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_edit_running = false;
      },
    });
  }
}
